// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1sNHh","bigColWidth":"Table_bigColWidth__1y9Gs","biggerColWidth":"Table_biggerColWidth__3jFBe","row":"Table_row__KOh1B","col":"Table_col__2vLTx"};